import { render, staticRenderFns } from "./SalaryTrackingModal.vue?vue&type=template&id=88c6c1c2&scoped=true"
import script from "./SalaryTrackingModal.vue?vue&type=script&lang=js"
export * from "./SalaryTrackingModal.vue?vue&type=script&lang=js"
import style0 from "./SalaryTrackingModal.vue?vue&type=style&index=0&id=88c6c1c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88c6c1c2",
  null
  
)

export default component.exports